import { IMessageTemplate } from "piramis-base-components/src/components/NewMessageEditors/NewMessageEditorWithMedia/types";
import { BasePunishActionModel } from ".";

export abstract class MessagePunishAction extends BasePunishActionModel {
  message!: Array<IMessageTemplate>
}
